import { Chip } from '@mui/material';

export default function DevIndicator() {
    return <Chip color="error" variant="outlined" label="DEV" sx={{ margin: 0.5 }} />;
}
